import React, {useEffect, useRef} from 'react';
import {minutes, useNamedSelector} from 'helpers';
import css from './current-time.module.scss';

export function CurrentTime() {
  const ref = useRef();
  const time = useNamedSelector('session.time');
  const ratio = minutes(time.format('h:mm A')) / (24*60);
  useEffect(() => {
    requestAnimationFrame(() => ref.current.scrollIntoView({block: 'center'}));
  }, []);
  return (
    <div className={css.line} style={{ top: ratio*100+'%' }} ref={ref}>
      <div className={css.label}>{ time.format('h:mm A') }</div>
    </div>
  );
}
